import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'


import { UrlManageService } from '../services/url-manage.service'

@Injectable({
  providedIn: 'root'
})
export class GraphSearchItemServiceService {

  constructor(
    private http: HttpClient,
    private urlList: UrlManageService
  ) { }



  searchType: string;
  searchValue: any;


  labels:any[] = [];
  properties = [];
  graphSearchValue = {
    startNode: {
      label: null,
      params: null
    },
    relationship: {
      label: null,
      params: null
    },
    endNode: {
      label: null,
      params: null
    }
  }


  getLabels(type) {
    if(type == "startNode" || type == "endNode"){
      return this.http.get(this.urlList.getEntryLabelUrl)
    }
    else if(type == "relation"){
      return this.http.get(this.urlList.getRelationLabelUrl)
    }
  }

  getProperties(label, type) {
    if(type == "startNode" || type == "endNode"){
      return this.http.get(this.urlList.getEntryPropertiesUrl + label)
    }
    else if(type == "relation"){
      return this.http.get(this.urlList.getRelationPropertiesUrl + label)
    }
  }

  setStartNodeValue(labelSelect ,startNodeValue) {
    this.graphSearchValue.startNode.label = labelSelect;
    this.graphSearchValue.startNode.params = startNodeValue;
  }

  setRelationValue(labelSelect ,relationValue) {
    this.graphSearchValue.relationship.label = labelSelect;
    this.graphSearchValue.relationship.params = relationValue;
  }

  setEndNodeValue(labelSelect ,endNode) {
    this.graphSearchValue.endNode.label = labelSelect;
    this.graphSearchValue.endNode.params = endNode;
  }

  getGraphSearchValue(){
    return this.graphSearchValue;
  }
}
